var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`h${_vm.level}`,{tag:"component",class:['v-heading', _vm.map[_vm.level]]},[(_vm.href)?_c('a',{staticClass:"text-decoration-none text-right text-md-left",attrs:{"href":_vm.href},on:{"click":_vm.onClick}},[_vm._v(" # ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }